const DadosFixos = {
	namespaced: true,
	state: {
		carregouDadosFixos: false,
		carregando: false,
		parametros: null,
	},
	mutations: {
		setCarregando(state, value){
			state.carregando = value;
		},
		setCarregouDadosFixos(state, value){
			state.carregouDadosFixos = value;
		},
		setParametros(state, dados){
			state.parametros = dados;
		},
	},
	actions: {},
	getters: {
		getCarregando: (state) => (state.carregando),
		getCarregouDadosFixos: (state) => (state.carregouDadosFixos),
		getParametros: (state) => (state.parametros),
	},
};

export default DadosFixos;
